import React from 'react'
import { Box, Grid, Modal } from '@mui/material'
import EQServiceCaregiver from '../../services/EQServiceCaregiver'
import Utils from '../../libs/Utils'
import EQState from '../../services/EQState'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '80%',
  bgcolor: '#FFE371',
  border: '0',
  boxShadow: 24,
  p: 2,
  alignContent: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}

export default class EQStartModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  closeModal() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  cancelOperation() {
    this.closeModal()
  }

  actuallyDoOperation() {
    EQServiceCaregiver.dichiaraInizio(this.props.selectedEvent).then((x) => {
      EQServiceCaregiver.getAppuntamento(
        this.props.selectedEvent.idCalendario
      ).then((x) => {
        Utils.refill(this.props.selectedEvent, x.data)
        EQState.change(EQState.CaregiverHome, {
          _selectedEvent: x.data,
        })
        this.closeModal()
      })
    })
  }

  render() {
    return (
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Box
            mt={0}
            p={0}
            pt={2}
            pb={2}>
            <div className="textCenter playFair app-text modal-title">
              <b>Tutto bene?</b>
            </div>
            <div className="textCenter playFair app-text">
              Conferma qui per dare inizio alla tua assistenza
            </div>

            <Grid
              container
              mt={0}
              mb={4}>
              <Grid
                item
                sx={{ textAlign: 'left' }}
                xs={6}>
                <a
                  className="buttonLink bg-red text-white lnkForward"
                  onClick={() => this.cancelOperation()}>
                  ANNULLA
                </a>
              </Grid>
              <Grid
                item
                sx={{ textAlign: 'right' }}
                xs={6}>
                <a
                  className="buttonLink bg-green text-white lnkForward"
                  onClick={() => this.actuallyDoOperation()}>
                  CONFERMO
                </a>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    )
  }
}
